import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILoggedInUser } from "../../types/User";
import { meApi } from "../../services/me";
import { notificationApi } from "../../services/notification";
import { IMyLocationInfo } from "../../types/GeoLocation";
import { GEO_LOCATION_KEY, GEO_POSITION_KEY } from "../../shared/constants";

export const resetAll = createAction("RESET_ALL");

interface IGlobalState {
  loggedInUser: ILoggedInUser | null;
  unreadNotificationCount: number;
  location: IMyLocationInfo | null;
}

const initialState: IGlobalState = {
  loggedInUser: null,
  unreadNotificationCount: 0,
  location: null
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setLoggedInUser: (state, action: PayloadAction<ILoggedInUser | null>) => {
      state.loggedInUser = action.payload;
    },
    setLocation: (state, action: PayloadAction<IMyLocationInfo | null>) => {
      state.location = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(resetAll, () => initialState)

      // .addMatcher(meApi.endpoints.getMe.matchPending, (_state, action) => {
      //   console.log('pending', action)
      // })
      .addMatcher(meApi.endpoints.getMe.matchFulfilled, (state, action) => {
        state.loggedInUser = action.payload;
      })
      .addMatcher(meApi.endpoints.getMe.matchRejected, (state, action) => {
        const rejectedAction = action as any;
        if (rejectedAction.payload.status === 400) {
          // const message = rejectedAction.payload?.data?.message;
        }
      })
      .addMatcher(
        notificationApi.endpoints.getUnreadNotificationCount.matchFulfilled,
        (state, action) => {
          if (!action.payload.error && action.payload.data)
            state.unreadNotificationCount = parseInt(action.payload.data);
        })
      .addMatcher(meApi.endpoints.getMyLocation.matchFulfilled, (state, action) => {
        state.location = action.payload.data;
        localStorage.setItem(GEO_POSITION_KEY, state?.location?.geoPosition || "");
        localStorage.setItem(GEO_LOCATION_KEY, state?.location?.geoLocation || "");
      });
  },
});

export const { setLoggedInUser, setLocation } = globalSlice.actions;

export default globalSlice.reducer;
